
export const ADMIN_HEADER = 'Admin'
export const IMAGE_UPLODER_HEADER = 'Image Uploader'
export const S3_UPLOAD_HEADER = 'S3 Uploader'
export const TARGETING_CONFIG_HEADER = 'Targeting Configuration'
export const YALLA_HEADER = 'Tag Generator'
export const REPORTING_HEADER = 'Reporting'
export const JS_CONFIG_HEADER = 'JS Configurer'